import { Injectable } from '@angular/core';
import { SpinnerService } from 'src/app/shared/services';
import * as blobUtil from 'blob-util';
import { saveAs } from 'file-saver';
import { GET_HEAT_PUMP_INVOICE } from '../queries/energy-credit.queries';
import { Apollo } from 'apollo-angular';
import { DialogService } from 'src/app/shared/services/dialog.service';

@Injectable({
  providedIn: 'root',
})
export class HeatPumpInvoiceDownloadService {
  constructor(
    private apolloClient: Apollo,
    private spinnerService: SpinnerService,
    private dialog: DialogService,
  ) {}

  downloadHeatPumpInvoiceDocuments(serialNumber: string): void {
    this.apolloClient
      .query({
        query: GET_HEAT_PUMP_INVOICE,
        variables: { payload: serialNumber },
      })
      .subscribe((result: any) => {
        try {
          this.spinnerService.show();
          const items: string[] = result.data.GetHeatPumpInvoice;
          items.forEach((content) => {
            const blob: Blob = blobUtil.base64StringToBlob(content);
            const file = new File([blob], `${serialNumber}.pdf`, {
              type: 'application/pdf',
            });
            saveAs(file);
          });
        } catch {
          this.dialog.openDialog(
            'Failed to download invoice',
            'An error occurred while downloading the invoice. Please try again.',
            'Cancel',
            'OK',
            false,
          );
        } finally {
          this.spinnerService.hide();
        }
      });
  }
}
